import { Box, Modal } from "@material-ui/core";
import React from "react";

// Wide modal with close on backdrop click
function CustomModal({ open, width, onClose, children, ...props }) {
  const modalWidth = width || "80%";
  return (
    <Modal open={open} onClose={onClose} {...props}>
      <Box
        onMouseDown={onClose}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Box
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: "white",
            borderRadius: 5,
            width: modalWidth,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
}

export default CustomModal;
